import styled from 'styled-components';
import { media } from 'app/utils/style';
import { colors, breakpoints } from 'app/variables';

export const OuterContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;

  background: linear-gradient(
    180deg,
    ${colors.pacificBlue} 0%,
    ${colors.white} 100%
  );
`;

export const FlexContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 0;

  ${media.mediumHigh`
    align-self: center;
  `}
`;
export const BodyContainer = styled.div`
  display: flex;
  flex-direction: row;
  min-height: unset;
  height: 100%;
  ${media.mediumDesktop`
    min-height: 600px;
    height: auto;
  `}
  ${media.mediumHigh`
    flex-direction: column;
    height: 100%;
    justify-content: center;
    margin: auto;
  `}
`;
export const Block = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  border-radius: 0;
  background-color: ${colors.white};
  color: ${colors.black};
  stroke: ${colors.black};
  width: 100vw;

  ${media.mediumHigh`
    min-height: 300px;
    max-width: 75vw;
    border-radius: 10px;
  `}

  ${media.mediumDesktop`
    padding: 2.5rem 2.5rem 0 2.5rem;
  `}

  ${media.xLargeDesktop`
    max-width: clamp(0px, 80%, ${breakpoints.xLargeDesktop});
    align-self: center;
  `}
`;
export const Content = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column-reverse;
  ${media.mediumDesktop`
    flex-direction: row;
    padding-bottom: 1rem;
    gap: 1.5rem;
  `}
`;
export const MobileHeading = styled.div`
  display: block;
  padding: 1.5rem;
  text-align: center;
  color: ${colors.king};
  text-transform: uppercase;

  ${media.mediumDesktop`
    display: none;
  `}
`;
export const ShareGroupContainer = styled.div`
  display: none;
  ${media.mediumDesktop`
    display: block;
    padding-bottom: 1rem;
  `}
`;
export const InfoContainer = styled.div`
  flex: 3;
  display: none;
  flex-direction: column;
  gap: 1rem;

  ${media.mediumHigh`
    display: flex;
  `}
`;
export const MainContentContainer = styled.div`
  flex: 2;
  display: flex;
  flex-direction: column;

  &:focus-visible {
    outline: none;
  }
`;
